import axios from "axios";
import { Company, CompanyReference } from "./Domain";
import useGlobalPromise from "./useGlobalPromise";

export default () =>
	useGlobalPromise("ald_companies", async () =>
		(await axios.get<Company[]>(`/api/companies`)).data
	);

export const getCompanyReference = (company: Company): CompanyReference => {
	return { id: company.id, name: company.name };
};

export const getCompanyReferenceByName = (companies: Company[], name: string) => {
	const company = companies.filter(c => c.name === name)[0];
	return getCompanyReference(company);
}

export const generateAssessmentCompanyChoices = (companies: Company[]) => {
	return ({
		"20": companies.filter(f => f.id === 20)[0].name, // Dekra
		"15": companies.filter(f => f.id === 15)[0].name // Macadam
	});
};
